import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/app/ui/assets/images/cod-logo.png'
import _imports_1 from '@/app/ui/assets/images/dfod-logo.png'


const _hoisted_1 = { class: "inline-flex" }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-center w-12/12 bg-gray-lp-200 rounded-md p-3"
}
const _hoisted_3 = { class: "mr-8 flex" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "bg-red-lp-100 rounded-full text-white text-xs w-6 h-6  mr-2 flex items-center justify-center" }, " 1 ", -1)
const _hoisted_5 = { class: "align-middle" }
const _hoisted_6 = { class: "ml-8 flex" }
const _hoisted_7 = {
  key: 1,
  class: "flex justify-between gap-x-8 w-10/12"
}
const _hoisted_8 = {
  key: 2,
  class: "flex justify-between gap-x-8 w-10/12"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "w-1/2" }, null, -1)
const _hoisted_10 = { class: "flex justify-between gap-x-8 w-10/12" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "w-6/12" }, null, -1)
const _hoisted_12 = { class: "flex justify-between gap-x-8 w-10/12" }
const _hoisted_13 = {
  key: 4,
  class: "flex gap-x-8 w-10/12"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "w-6/12" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_16 = { class: "flex justify-between" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_18 = { class: "space-y-2" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "text-12px text-gray-lp-500 w-8/12" }, " Setiap barang yang dibooking oleh Client akan menyesuaikan dengan layanan yang telah dipilih. ", -1)
const _hoisted_20 = { class: "flex justify-between gap-x-8 w-10/12" }
const _hoisted_21 = { class: "p-field-checkbox mt-3 ml-2 mb-2" }
const _hoisted_22 = /*#__PURE__*/_createVNode("label", {
  class: "ml-2.5 mt-4",
  for: "cod"
}, "COD", -1)
const _hoisted_23 = { class: "p-field-checkbox mt-3 ml-2 mb-2" }
const _hoisted_24 = /*#__PURE__*/_createVNode("label", {
  class: "ml-2.5",
  for: "do"
}, "Delivery Order", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_27 = { class: "flex w-10/12 bg-gray-lp-200 p-4 pl-6 rounded-md text-black-lp-300" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "w-10/12 pt-2" }, [
  /*#__PURE__*/_createVNode("p", null, "Sama dengan detail Cabang Client")
], -1)
const _hoisted_29 = { class: "w-2/12 pl-6" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "toggle-knob bg-white inline-block" }, null, -1)
const _hoisted_31 = { class: "flex justify-between gap-x-8 w-10/12" }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_33 = { class: "flex flex-col gap-x-8 w-10/12" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "p-field-checkbox mt-3 ml-2 mb-2 flex flex-row" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    class: "max-w-none w-16",
    alt: "cod-logo"
  }),
  /*#__PURE__*/_createVNode("label", {
    for: "cod",
    class: "mt-4 ml-2.5"
  }, "Cash on Delivery")
], -1)
const _hoisted_35 = { class: "flex w-7/12 bg-gray-lp-200 p-4 pl-6 rounded-md text-black-lp-300 mb-6" }
const _hoisted_36 = { class: 
                  `p-field-radiobutton gap-x-3 flex flex-row` }
const _hoisted_37 = /*#__PURE__*/_createVNode("label", {
  for: `radio-goodsPrice`,
  class: `cursor-pointer flex`
}, [
  /*#__PURE__*/_createVNode("label", { for: "cod" }, "Harga Barang")
], -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("label", {
  for: `radio-goodsPrice`,
  class: `cursor-pointer flex`
}, [
  /*#__PURE__*/_createVNode("label", { for: "cod" }, "Harga Barang + ongkir klien")
], -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_40 = { class: "p-field-checkbox mt-3 ml-2 mb-2 flex flex-row" }
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row ml-2.5" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    class: "max-w-none w-16",
    alt: "cod-logo"
  }),
  /*#__PURE__*/_createVNode("label", {
    class: "ml-2.5 mt-2",
    for: "do"
  }, "Delivery Order")
], -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_43 = { class: "flex justify-between gap-x-8 w-10/12" }
const _hoisted_44 = { class: "flex justify-between gap-x-8 w-10/12" }
const _hoisted_45 = {
  key: 1,
  class: "w-6/12"
}
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_47 = { class: "flex justify-between gap-x-8 w-10/12" }
const _hoisted_48 = { class: "flex justify-between gap-x-8 w-10/12" }
const _hoisted_49 = { class: "py-1.5" }
const _hoisted_50 = { class: "flex justify-between gap-x-8 w-10/12" }
const _hoisted_51 = /*#__PURE__*/_createVNode("div", { class: "w-6/12" }, null, -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_53 = { class: "flex justify-between gap-x-8 w-10/12" }
const _hoisted_54 = { class: "flex justify-between gap-x-8 w-10/12" }
const _hoisted_55 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_56 = { class: "w-12/12 my-4" }
const _hoisted_57 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" Diskon ")
const _hoisted_59 = { class: "ml-1 relative" }
const _hoisted_60 = /*#__PURE__*/_createVNode("div", { class: "mt-2 text-12px xxl:text-14px" }, " Download template dibawah untuk berkas lampiran harga khusus yang akan diunggah. ", -1)
const _hoisted_61 = { class: "flex items-center w-full" }
const _hoisted_62 = { class: "whitespace-no-wrap text-red-lp-100" }
const _hoisted_63 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_64 = { class: "space-y-2" }
const _hoisted_65 = /*#__PURE__*/_createVNode("div", { class: "text-12px text-gray-lp-500 w-8/12" }, " Harga akan berlaku sesuai dengan tanggal periode yang dipilih. Harga client mencakup harga normal, khusus, dan kombinasi. ", -1)
const _hoisted_66 = { class: "flex gap-x-8 w-10/12" }
const _hoisted_67 = { class: "text-red-lp-100 text-12px xxl:text-14px" }
const _hoisted_68 = { class: "text-red-lp-100 text-12px xxl:text-14px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Title = _resolveComponent("Title")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Select = _resolveComponent("Select")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_SelectPhoneCountry = _resolveComponent("SelectPhoneCountry")!
  const _component_TaxSection = _resolveComponent("TaxSection")!
  const _component_ToggleV2 = _resolveComponent("ToggleV2")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_DetailDeliveryOrder = _resolveComponent("DetailDeliveryOrder")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_BillingSection = _resolveComponent("BillingSection")!
  const _component_BankSection = _resolveComponent("BankSection")!
  const _component_BankSettlementSection = _resolveComponent("BankSettlementSection")!
  const _component_CardSelector = _resolveComponent("CardSelector")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_UploadFile = _resolveComponent("UploadFile")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      onBack: _ctx.goBack,
      title: _ctx.getTitle,
      "vertical-separator": false
    }, {
      "top-right": _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          (_ctx.isFisrtStep && _ctx.formType === 'parent')
            ? (_openBlock(), _createBlock(_component_button_fill, {
                key: 0,
                isDisabled: !_ctx.isFormFirstStepValid,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchStep(1))),
                title: "Selanjutnya",
                class: "bg-red-lp-300 px-8"
              }, null, 8, ["isDisabled"]))
            : (_openBlock(), _createBlock(_component_button_fill, {
                key: 1,
                isDisabled: 
            _ctx.formType === 'branch' ? !_ctx.isFormValidBranch : !_ctx.isFormValid
          ,
                onClick: _ctx.onOpenSave,
                title: "Simpan",
                class: "bg-red-lp-300 px-8"
              }, null, 8, ["isDisabled", "onClick"]))
        ])
      ]),
      data: _withCtx(() => [
        (_ctx.formType === 'parent')
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode("div", {
                  class: "cursor-pointer text-red-lp-300 font-bold",
                  style: {"font-size":"16px"},
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchStep(0)))
                }, " Detail Induk Client ")
              ]),
              _createVNode("div", _hoisted_5, [
                _createVNode("img", {
                  class: "w-6 h-6",
                  src: require('@/app/ui/assets/svg/separtor_chevron.svg'),
                  alt: ""
                }, null, 8, ["src"])
              ]),
              _createVNode("div", _hoisted_6, [
                _createVNode("div", {
                  class: 
                `${
                  _ctx.isFormFirstStepValid
                    ? 'bg-red-lp-100 text-white'
                    : 'bg-gray-lp-1000 text-gray-lp-800'
                } rounded-full text-xs w-6 h-6 mr-2 flex items-center justify-center`
              
                }, " 2 ", 2),
                _createVNode("div", {
                  class: 
                `${
                  _ctx.isFormFirstStepValid
                    ? 'text-red-lp-300 cursor-pointer'
                    : 'text-gray-lp-800'
                } font-bold`
              ,
                  style: {"font-size":"16px"},
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isFormFirstStepValid ? _ctx.switchStep(1) : null))
                }, " Jenis Harga ", 2)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isFisrtStep)
          ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_Title, { label: _ctx.getClientName }, null, 8, ["label"]),
              (_ctx.formType === 'branch')
                ? (_openBlock(), _createBlock(_component_DataWrapper, {
                    key: 0,
                    label: "Nama Cabang client",
                    class: "w-10/12",
                    asterisk: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lp_input, {
                        modelValue: _ctx.form.companyName,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.companyName = $event)),
                        placeholder: "Masukan nama client",
                        onChange: _ctx.fullFilledCodReceiver
                      }, null, 8, ["modelValue", "onChange"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.formType === 'parent')
                ? (_openBlock(), _createBlock("div", _hoisted_7, [
                    _createVNode(_component_DataWrapper, {
                      label: "Nama Induk Client",
                      class: "w-6/12",
                      asterisk: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lp_input, {
                          modelValue: _ctx.form.companyName,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.companyName = $event)),
                          placeholder: "Masukan nama client"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DataWrapper, {
                      label: "Kategori Client",
                      class: "w-6/12",
                      asterisk: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Select, {
                          onOpenSelect: _ctx.onOpenSelectClientCategory,
                          onCloseSelect: _ctx.onCloseSelectClientCategory,
                          isOpenMenu: _ctx.isOpenClientCategory,
                          value: _ctx.form.clientCategory,
                          onChooseSelect: _ctx.onSelectClientCategory,
                          dataSelect: _ctx.clientCategoryList,
                          class: "w-full whitespace-no-wrap my-2"
                        }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formType === 'parent')
                ? (_openBlock(), _createBlock("div", _hoisted_8, [
                    _createVNode(_component_DataWrapper, {
                      label: "Company Size",
                      class: "w-1/2",
                      asterisk: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Select, {
                          onOpenSelect: _ctx.onOpenSelectCompanySize,
                          onCloseSelect: _ctx.onCloseSelectCompanySize,
                          isOpenMenu: _ctx.isOpenCompanySize,
                          value: _ctx.form.companySize,
                          onChooseSelect: _ctx.onSelectCompanySize,
                          dataSelect: _ctx.companySizeList,
                          class: "w-full whitespace-no-wrap my-2"
                        }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                      ]),
                      _: 1
                    }),
                    _hoisted_9
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_DataWrapper, {
                label: "Alamat",
                class: "w-10/12",
                asterisk: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    type: "textarea",
                    modelValue: _ctx.form.address,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.address = $event)),
                    placeholder: "Masukan alamat client",
                    onChange: _ctx.fullFilledCodAddressReceiver
                  }, null, 8, ["modelValue", "onChange"])
                ]),
                _: 1
              }),
              _createVNode("div", _hoisted_10, [
                _createVNode(_component_DataWrapper, {
                  label: "Kecamatan, Kota",
                  class: "w-6/12",
                  asterisk: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectSearch, {
                      class: "my-1",
                      onFilter: _ctx.fetchDistrictList,
                      isLoading: _ctx.loadingDistrictList,
                      options: _ctx.districtList,
                      error: _ctx.error.district,
                      keyName: "name",
                      keyValue: "id",
                      placeholder: "Ketik atau pilih lokasi",
                      modelValue: _ctx.form.district,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.district = $event)),
                      onChange: _ctx.getPOSByCity
                    }, null, 8, ["onFilter", "isLoading", "options", "error", "modelValue", "onChange"])
                  ]),
                  _: 1
                }),
                _hoisted_11
              ]),
              _createVNode("div", _hoisted_12, [
                _createVNode(_component_DataWrapper, {
                  label: "Email",
                  class: "w-6/12",
                  asterisk: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.form.email,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.email = $event)),
                      type: "email",
                      onChange: _ctx.validateEmail,
                      error: _ctx.error.email,
                      errorCaption: "Masukan Email dengan benar",
                      placeholder: "e.g email@gmail.com"
                    }, null, 8, ["modelValue", "onChange", "error"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DataWrapper, {
                  label: "No. Telepon",
                  class: "w-6/12",
                  asterisk: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectPhoneCountry, {
                      phone: _ctx.form.phone,
                      code: _ctx.phoneCodeMain,
                      error: _ctx.errorPhoneMain,
                      column: "Kontak",
                      placeholder: "81119600999"
                    }, null, 8, ["phone", "code", "error"])
                  ]),
                  _: 1
                })
              ]),
              (_ctx.formType === 'parent')
                ? (_openBlock(), _createBlock(_component_TaxSection, {
                    key: 3,
                    form: _ctx.form.tax,
                    error: _ctx.error
                  }, null, 8, ["form", "error"]))
                : (_openBlock(), _createBlock("div", _hoisted_13, [
                    _createVNode(_component_DataWrapper, {
                      label: "No. Registrasi Pajak (NPWP)",
                      class: "w-6/12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lp_input, {
                          format: _ctx.formatted,
                          onChange: _ctx.validateTaxNumber,
                          error: _ctx.error.taxNumber,
                          errorCaption: "Masukan No. Registrasi Pajak (NPWP) dengan benar",
                          modelValue: _ctx.form.taxNumber,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.taxNumber = $event)),
                          placeholder: "00.000.000.0-000.000",
                          maxLength: "20",
                          "show-max-length": ""
                        }, null, 8, ["format", "onChange", "error", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_14
                  ])),
              (_ctx.formType === 'branch')
                ? (_openBlock(), _createBlock(_Fragment, { key: 5 }, [
                    _hoisted_15,
                    _createVNode("div", _hoisted_16, [
                      _createVNode(_component_Title, { label: "Konfigurasi retur" }),
                      _createVNode(_component_ToggleV2, {
                        onClick: _cache[10] || (_cache[10] = () => _ctx.toggleReturnConfig()),
                        "model-value": _ctx.form.isReturnConfig,
                        "style-active": _ctx.toggle-_ctx.active
                      }, null, 8, ["model-value", "style-active"])
                    ]),
                    (_ctx.form.isReturnConfig)
                      ? (_openBlock(), _createBlock(_component_DataWrapper, {
                          key: 0,
                          label: "Batas konfirmasi retur",
                          optional: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_LpInput, {
                              modelValue: _ctx.form.returnConfigLimit,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.returnConfigLimit = $event)),
                              placeholder: "Batas konfirmasi retur",
                              "max-length": 3,
                              suffix: "hari"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.form.isReturnConfig)
                      ? (_openBlock(), _createBlock(_component_DataWrapper, {
                          key: 1,
                          label: "Alasan retur perlu dikonfirmasi",
                          optional: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_MultipleSelectSearch, {
                              options: _ctx.reasonList,
                              modelValue: _ctx.form.returnConfigReasonIds,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.returnConfigReasonIds = $event)),
                              modalTitle: "Return Reason List",
                              keyName: "name",
                              keyValue: "value",
                              placeholder: "Pilih alasan",
                              "custom-display-all": "Semua alasan",
                              onFilter: _ctx.onSearchAddObject
                            }, null, 8, ["options", "modelValue", "onFilter"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _hoisted_17,
                    _createVNode("div", _hoisted_18, [
                      _createVNode(_component_Title, { label: "Layanan Pengiriman" }),
                      _hoisted_19
                    ]),
                    _createVNode("div", _hoisted_20, [
                      _createVNode(_component_DataWrapper, { class: "w-6/12" }, {
                        default: _withCtx(() => [
                          _createVNode("div", _hoisted_21, [
                            _createVNode(_component_Checkbox, {
                              id: "cod",
                              modelValue: _ctx.form.cod,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form.cod = $event)),
                              binary: true,
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.form.codRej.codAmountType = ''))
                            }, null, 8, ["modelValue"]),
                            _hoisted_22
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DataWrapper, { class: "w-6/12" }, {
                        default: _withCtx(() => [
                          _createVNode("div", _hoisted_23, [
                            _createVNode(_component_Checkbox, {
                              id: "do",
                              modelValue: _ctx.form.do,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.form.do = $event)),
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.form.clientBranchDoPaymentType = '')),
                              binary: true
                            }, null, 8, ["modelValue"]),
                            _hoisted_24
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.formType === 'branch')
                ? (_openBlock(), _createBlock(_Fragment, { key: 6 }, [
                    (_ctx.form.do)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _hoisted_25,
                          _createVNode(_component_DetailDeliveryOrder, {
                            detailData: _ctx.form,
                            isForm: ""
                          }, null, 8, ["detailData"])
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.form.cod)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                          _hoisted_26,
                          _createVNode(_component_Title, { label: "Pengembalian STT return" }),
                          _createVNode("div", _hoisted_27, [
                            _hoisted_28,
                            _createVNode("div", _hoisted_29, [
                              _createVNode("div", {
                                onClick: _cache[17] || (_cache[17] = () => _ctx.autoFill()),
                                class: 
                    `toggle-switch inline-block cursor-pointer ${
                      _ctx.isFill ? 'toggle-active bg-red-lp-100' : 'bg-gray-lp-200'
                    }`
                  
                              }, [
                                _hoisted_30
                              ], 2)
                            ])
                          ]),
                          _createVNode(_component_Title, { label: "Detail Penerima" }),
                          _createVNode(_component_DataWrapper, {
                            label: "Nama Penerima",
                            class: "w-10/12",
                            asterisk: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_lp_input, {
                                modelValue: _ctx.form.codRej.receiverName,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.form.codRej.receiverName = $event)),
                                placeholder: "Masukan nama client",
                                disabled: _ctx.autoFillColumnDisabled
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_DataWrapper, {
                            label: "Alamat Penerima",
                            class: "w-10/12",
                            asterisk: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_lp_input, {
                                type: "textarea",
                                modelValue: _ctx.form.codRej.receiverAddress,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.form.codRej.receiverAddress = $event)),
                                placeholder: "Masukan alamat client",
                                disabled: _ctx.autoFillColumnDisabled
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode("div", _hoisted_31, [
                            _createVNode(_component_DataWrapper, {
                              label: "Kecamatan, Kota",
                              class: "w-6/12",
                              asterisk: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_SelectSearch, {
                                  class: "my-1",
                                  onFilter: _ctx.fetchDistrictList,
                                  isLoading: _ctx.loadingDistrictList,
                                  options: _ctx.districtList,
                                  error: _ctx.error.codRejdistrict,
                                  keyName: "name",
                                  keyValue: "id",
                                  placeholder: "Masukan atau pilih lokasi",
                                  modelValue: _ctx.form.codRej.district,
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.form.codRej.district = $event)),
                                  isDisabled: _ctx.autoFillColumnDisabled
                                }, null, 8, ["onFilter", "isLoading", "options", "error", "modelValue", "isDisabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_DataWrapper, {
                              label: "No. Telepon",
                              class: "w-6/12",
                              asterisk: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_SelectPhoneCountry, {
                                  phone: _ctx.form.codRej.phone,
                                  code: _ctx.codRejPhoneCode,
                                  error: _ctx.errorCodRejPhone,
                                  column: "Kontak",
                                  placeholder: "81119600999",
                                  disabled: _ctx.autoFillColumnDisabled
                                }, null, 8, ["phone", "code", "error", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _hoisted_32,
                          _createVNode(_component_Title, { label: "Tipe COD" }),
                          _createVNode("div", _hoisted_33, [
                            _createVNode(_component_DataWrapper, { class: "w-6/12" }, {
                              default: _withCtx(() => [
                                _hoisted_34
                              ]),
                              _: 1
                            }),
                            _createVNode("div", _hoisted_35, [
                              _createVNode("div", _hoisted_36, [
                                _createVNode(_component_RadioButton, {
                                  id: `radio-goods-price`,
                                  name: "surcharge-status",
                                  value: "goods_price",
                                  modelValue: _ctx.form.codRej.codAmountType,
                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.form.codRej.codAmountType = $event)),
                                  onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onChangeDeliveryFeeType('goods_price')))
                                }, null, 8, ["modelValue"]),
                                _hoisted_37,
                                _createVNode(_component_RadioButton, {
                                  id: `radio-goods-price-total-tarif`,
                                  name: "surcharge-status",
                                  value: "goods_price,total_tarif",
                                  modelValue: _ctx.form.codRej.codAmountType,
                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.form.codRej.codAmountType = $event)),
                                  onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.onChangeDeliveryFeeType('goods_price,total_tarif')))
                                }, null, 8, ["modelValue"]),
                                _hoisted_38
                              ])
                            ])
                          ]),
                          _hoisted_39,
                          _createVNode(_component_DataWrapper, { class: "w-6/12 mt-4" }, {
                            default: _withCtx(() => [
                              _createVNode("div", _hoisted_40, [
                                _createVNode(_component_Checkbox, {
                                  id: "do",
                                  modelValue: _ctx.form.clientIsDfod,
                                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.form.clientIsDfod = $event)),
                                  binary: true
                                }, null, 8, ["modelValue"]),
                                _hoisted_41
                              ])
                            ]),
                            _: 1
                          }),
                          _hoisted_42,
                          _createVNode(_component_Title, { label: "Biaya & persentase COD" }),
                          _createVNode("div", _hoisted_43, [
                            _createVNode(_component_DataWrapper, {
                              label: "Biaya COD",
                              class: "w-6/12",
                              icon: "info",
                              iconActive: "info-red",
                              tooltipTitle: "Bagaimana Perhitungan Biaya COD?",
                              tooltipDescription: "Biaya COD dihitung dari persentase total COD amount"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_lp_input, {
                                  format: _ctx.formatFloat,
                                  modelValue: _ctx.form.codRej.commision,
                                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.form.codRej.commision = $event)),
                                  error: _ctx.error.codRejCommision,
                                  onChange: _ctx.validateCodRejCommision,
                                  errorCaption: _ctx.errorCaptionCodRejCommision,
                                  placeholder: "e.g 20",
                                  min: "0",
                                  max: "100",
                                  suffix: "%"
                                }, null, 8, ["format", "modelValue", "error", "onChange", "errorCaption"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_DataWrapper, {
                              label: "Persentase Diskon COD",
                              class: "w-6/12",
                              icon: "info",
                              iconActive: "info-red",
                              tooltipTitle: "Info Persentase Diskon COD",
                              tooltipDescription: _ctx.tooltipCODShipmentDiscount
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_lp_input, {
                                  format: _ctx.formatFloat,
                                  modelValue: _ctx.form.codRej.codShipmentDiscount,
                                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.form.codRej.codShipmentDiscount = $event)),
                                  error: _ctx.error.codRejShipmentDiscount,
                                  onChange: _ctx.validateCodRejShipmentDiscount,
                                  errorCaption: _ctx.errorCaptionCodRejShipmentDiscount,
                                  placeholder: "Masukkan persentase diskon COD",
                                  min: "0",
                                  max: "100",
                                  suffix: "%"
                                }, null, 8, ["format", "modelValue", "error", "onChange", "errorCaption"])
                              ]),
                              _: 1
                            }, 8, ["tooltipDescription"])
                          ]),
                          _createVNode("div", _hoisted_44, [
                            (_ctx.isEnableCodBooking)
                              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                                  key: 0,
                                  label: "Biaya PAD",
                                  class: "w-6/12",
                                  icon: "info",
                                  iconActive: "info-red",
                                  tooltipDescription: "Biaya PAD akan ditambahkan ke Biaya PAD"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_lp_input, {
                                      format: _ctx.formatFloat,
                                      modelValue: _ctx.form.codRej.padCommision,
                                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.form.codRej.padCommision = $event)),
                                      error: _ctx.error.padCommision,
                                      onChange: _ctx.validatePadCommision,
                                      errorCaption: _ctx.errorCaptionPadCommision,
                                      placeholder: "e.g 20",
                                      min: "0",
                                      max: "100",
                                      suffix: "%"
                                    }, null, 8, ["format", "modelValue", "error", "onChange", "errorCaption"])
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock("div", _hoisted_45))
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                    _hoisted_46,
                    _createVNode(_component_Title, { label: "Detail Induk Client" }),
                    _createVNode("div", _hoisted_47, [
                      _createVNode(_component_DataWrapper, {
                        label: "Nama Induk Client",
                        class: "w-6/12",
                        asterisk: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_SelectSearch, {
                            options: _ctx.clientList,
                            onFilter: _ctx.filterClient,
                            keyName: "name",
                            keyValue: "id",
                            placeholder: "Masukan atau pilih induk client",
                            modelValue: _ctx.form.parent.parentName,
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.form.parent.parentName = $event)),
                            isLoading: _ctx.isLoadingClient,
                            class: "my-2"
                          }, null, 8, ["options", "onFilter", "modelValue", "isLoading"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DataWrapper, {
                        label: "Nama POS",
                        optional: true,
                        class: "w-6/12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_SelectSearch, {
                            options: _ctx.posList,
                            onFilter: _ctx.filterPOS,
                            keyName: "name",
                            keyValue: "id",
                            placeholder: "Masukan atau pilih POS",
                            modelValue: _ctx.form.parent.posName,
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.form.parent.posName = $event)),
                            isLoading: _ctx.isLoadingPOS,
                            class: "my-2"
                          }, null, 8, ["options", "onFilter", "modelValue", "isLoading"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("div", _hoisted_48, [
                      _createVNode(_component_DataWrapper, {
                        label: "Komisi",
                        class: "w-6/12",
                        asterisk: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_lp_input, {
                            format: _ctx.formatFloat,
                            modelValue: _ctx.form.parent.commision,
                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.form.parent.commision = $event)),
                            error: _ctx.error.commision,
                            onChange: _ctx.validateCommision,
                            errorCaption: _ctx.errorCaptionCommision,
                            placeholder: "e.g 20",
                            min: "0",
                            max: "100",
                            suffix: "%"
                          }, null, 8, ["format", "modelValue", "error", "onChange", "errorCaption"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DataWrapper, {
                        label: "Tipe Komisi",
                        class: "w-6/12",
                        asterisk: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode("div", _hoisted_49, [
                            _createVNode(_component_Select, {
                              onOpenSelect: _ctx.onOpenSelectCommissionType,
                              onCloseSelect: _ctx.onCloseSelectCommissionType,
                              isOpenMenu: _ctx.isOpenCommissionType,
                              value: _ctx.form.parent.commisionType,
                              onChooseSelect: _ctx.onSelectCommissionType,
                              dataSelect: _ctx.commisionTypes,
                              class: "w-full whitespace-no-wrap my-2"
                            }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("div", _hoisted_50, [
                      _createVNode(_component_DataWrapper, {
                        label: "Pembilang Komisi",
                        class: "w-6/12",
                        asterisk: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Select, {
                            onOpenSelect: _ctx.onOpenSelectNumeratorCommission,
                            onCloseSelect: _ctx.onCloseSelectNumeratorCommission,
                            isOpenMenu: _ctx.isOpenNumeratorCommission,
                            value: _ctx.form.parent.numeratorCommission,
                            onChooseSelect: _ctx.onSelectNumeratorCommission,
                            dataSelect: _ctx.numeratorCommissionList,
                            class: "w-full whitespace-no-wrap my-2"
                          }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                        ]),
                        _: 1
                      }),
                      _hoisted_51
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _hoisted_52,
              _createVNode(_component_Title, { label: "Informasi Kontak" }),
              _createVNode("div", _hoisted_53, [
                _createVNode(_component_DataWrapper, {
                  label: "Nama",
                  class: "w-6/12",
                  asterisk: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.form.contact.name,
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.form.contact.name = $event)),
                      type: "Nama",
                      placeholder: "Masukan nama"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DataWrapper, {
                  label: "Jabatan",
                  class: "w-6/12",
                  asterisk: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.form.contact.level,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.form.contact.level = $event)),
                      type: "Jabatan",
                      placeholder: "Masukan jabatan"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode("div", _hoisted_54, [
                _createVNode(_component_DataWrapper, {
                  label: "Email",
                  class: "w-6/12",
                  asterisk: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.form.contact.email,
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.form.contact.email = $event)),
                      type: "email",
                      onChange: _ctx.validateContactEmail,
                      error: _ctx.error.contactEmail,
                      errorCaption: "Masukan Email dengan benar",
                      placeholder: "e.g email@gmail.com"
                    }, null, 8, ["modelValue", "onChange", "error"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DataWrapper, {
                  label: "No. Telepon",
                  class: "w-6/12",
                  asterisk: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectPhoneCountry, {
                      phone: _ctx.form.contact.phone,
                      code: _ctx.contactPhoneCode,
                      error: _ctx.errorContactPhone,
                      column: "Kontak",
                      placeholder: "81119600999"
                    }, null, 8, ["phone", "code", "error"])
                  ]),
                  _: 1
                })
              ]),
              (_ctx.formType === 'parent')
                ? (_openBlock(), _createBlock(_Fragment, { key: 7 }, [
                    _hoisted_55,
                    _createVNode(_component_Title, { label: "Informasi Pembayaran" }),
                    _createVNode(_component_DataWrapper, {
                      label: "Metode Pembayaran",
                      class: "w-6/12",
                      asterisk: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Select, {
                          onOpenSelect: _ctx.onOpenPaymentMethod,
                          onCloseSelect: _ctx.onCloseSelectPaymentMethod,
                          isOpenMenu: _ctx.isOpePaymentMethod,
                          value: _ctx.form.paymentMethod,
                          onChooseSelect: _ctx.onSelectPaymentMethod,
                          dataSelect: _ctx.paymentMethodList,
                          class: "w-full whitespace-no-wrap my-2"
                        }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_BillingSection, {
                      form: _ctx.form.billingInformation,
                      error: _ctx.error
                    }, null, 8, ["form", "error"]),
                    _createVNode(_component_BankSection, { formType: "add" }),
                    _createVNode(_component_BankSettlementSection, { formType: "add" })
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.formType === 'parent' && !_ctx.isFisrtStep)
          ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
              _createVNode(_component_Title, {
                label: "Pilihan Harga",
                class: "my-4"
              }),
              _createVNode("div", _hoisted_56, [
                _createVNode(_component_CardSelector, {
                  modelValue: _ctx.form.isCustomRate,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.form.isCustomRate = $event)),
                  options: _ctx.customPriceOption
                }, null, 8, ["modelValue", "options"])
              ]),
              _withDirectives(_createVNode("div", null, [
                _createVNode(_component_DataWrapper, {
                  label: "Versi Harga Normal",
                  class: "w-10/12 mb-5",
                  asterisk: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectSearch, {
                      class: "my-1",
                      onFilter: _ctx.fetchVersionRates,
                      isLoading: _ctx.loadingVersionRates,
                      options: _ctx.versionRates,
                      keyName: "rateVersionName",
                      keyValue: "rateVersionName",
                      placeholder: "pilih versi harga",
                      modelValue: _ctx.form.versionBasic,
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.form.versionBasic = $event))
                    }, null, 8, ["onFilter", "isLoading", "options", "modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DataWrapper, { class: "w-2/12" }, {
                  label: _withCtx(() => [
                    _createVNode("div", _hoisted_57, [
                      _hoisted_58,
                      _createVNode("div", _hoisted_59, [
                        _createVNode("img", {
                          onMouseenter: _cache[37] || (_cache[37] = ($event: any) => (_ctx.toolTipDiscount = true)),
                          onMouseleave: _cache[38] || (_cache[38] = ($event: any) => (_ctx.toolTipDiscount = false)),
                          src: 
                      _ctx.toolTipDiscount
                        ? require('@/app/ui/assets/svg/info-red.svg')
                        : require('@/app/ui/assets/svg/info.svg')
                    ,
                          alt: ""
                        }, null, 40, ["src"]),
                        _withDirectives(_createVNode(_component_Tooltip, {
                          title: "Diskon",
                          message: "Diskon hanya dapat dibuat dengan nilai 0-30%. Diskon dengan nilai 21-30% akan melalui proses approval dari manager.",
                          footer: "",
                          isArrowBottom: false,
                          style: {"width":"300px","margin-left":"2.6em","margin-top":"-2.6em"}
                        }, null, 512), [
                          [_vShow, _ctx.toolTipDiscount]
                        ])
                      ])
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_lp_input, {
                      format: _ctx.formatFloat,
                      modelValue: _ctx.form.discount,
                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (_ctx.form.discount = $event)),
                      error: _ctx.error.discount,
                      onChange: _ctx.validateDiscount,
                      errorCaption: "Masukan diskon 0 sampai 30",
                      placeholder: "e.g 20",
                      min: "0",
                      max: "100",
                      hint: "Masukan 0 bila tidak ada diskon",
                      suffix: "%"
                    }, null, 8, ["format", "modelValue", "error", "onChange"])
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _ctx.form.isCustomRate === 0 || _ctx.form.isCustomRate === 2]
              ]),
              _withDirectives(_createVNode("div", null, [
                _createVNode(_component_DataWrapper, {
                  label: "Template Harga Khusus",
                  class: "w-10/12 mb-5"
                }, {
                  default: _withCtx(() => [
                    _hoisted_60,
                    _createVNode("div", _hoisted_61, [
                      _createVNode("div", _hoisted_62, _toDisplayString(_ctx.templateFile), 1),
                      _createVNode(_component_lp_button, {
                        onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.download(_ctx.templateFileLink, _ctx.templateFileName))),
                        "text-color": "red-lp-300",
                        flat: "",
                        small: "",
                        icon: "download"
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DataWrapper, {
                  label: "Versi Harga Khusus",
                  class: "w-10/12 mb-5",
                  asterisk: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.form.versionName,
                      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (_ctx.form.versionName = $event)),
                      placeholder: "Masukan versi harga",
                      error: _ctx.isExist,
                      errorCaption: "Data nama versi sudah tersedia",
                      onChange: _cache[42] || (_cache[42] = () => _ctx.setIsExist(false))
                    }, null, 8, ["modelValue", "error"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DataWrapper, {
                  label: "Berkas Lampiran",
                  class: "w-10/12",
                  asterisk: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_UploadFile, {
                      "check-column": _ctx.columnToValidate,
                      maxRows: 160000,
                      type: "csv",
                      modelValue: _ctx.form.archiveFile,
                      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (_ctx.form.archiveFile = $event))
                    }, null, 8, ["check-column", "modelValue"])
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _ctx.form.isCustomRate === 1 || _ctx.form.isCustomRate === 2]
              ]),
              _hoisted_63,
              _createVNode("div", _hoisted_64, [
                _createVNode(_component_Title, {
                  label: "Periode Harga",
                  required: ""
                }),
                _hoisted_65
              ]),
              _createVNode("div", _hoisted_66, [
                _createVNode(_component_DataWrapper, {
                  label: "Dimulai Dari",
                  class: "w-6/12"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DatePicker, {
                      class: "my-2",
                      modelValue: _ctx.form.priceRateStartDate,
                      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (_ctx.form.priceRateStartDate = $event)),
                      minDate: new Date(new Date().setDate(new Date().getDate() + 1))
                    }, null, 8, ["modelValue", "minDate"]),
                    _withDirectives(_createVNode("div", _hoisted_67, " Tanggal mulai tidak boleh lebih atau sama dengan tanggal akhir ", 512), [
                      [_vShow, _ctx.validateStartEndDate]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DataWrapper, {
                  label: "Sampai",
                  class: "w-6/12"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DatePicker, {
                      class: "my-2",
                      modelValue: _ctx.form.priceRateEndDate,
                      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (_ctx.form.priceRateEndDate = $event)),
                      minDate: _ctx.form.priceRateStartDate
                    }, null, 8, ["modelValue", "minDate"]),
                    _withDirectives(_createVNode("div", _hoisted_68, " Tanggal akhir tidak boleh kurang atau sama dengan tanggal mulai ", 512), [
                      [_vShow, _ctx.validateStartEndDate]
                    ])
                  ]),
                  _: 1
                })
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onBack", "title"]),
    (_ctx.isErrorEdit)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 0,
          onCancel: _ctx.handleErrorClose,
          errorType: _ctx.errorCause,
          onTryAgain: _ctx.formType === 'branch' ? _ctx.createClientBranch : _ctx._onAdd,
          modal: ""
        }, null, 8, ["onCancel", "errorType", "onTryAgain"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: "Yakin Keluar Halaman ?",
      message: "\n      Anda belum selesai mengisi form. Permintaan tidak akan diproses jika Anda keluar dari halaman ini.\n    ",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isAddTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.formType === 'branch' ? _ctx.createClientBranch : _ctx._onAdd,
      onClose: _ctx.onCloseSave,
      title: "Konfirmasi Pembuatan",
      message: 
      `Anda yakin ingin menyimpan pembuatan Client “${_ctx.form.companyName}“`
    ,
      image: "are-you-sure",
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "message"]), [
      [_vShow, _ctx.openSave]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.goBack,
      title: "Pembuatan Gagal !",
      message: 
      `Berkas Custom Rates salah atau tidak sesuai.\nSilahkan klik Ubah File untuk perbaiki.`
    ,
      image: "image-modal-failed",
      textSuccess: "OK",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.isErrorDocument]
    ])
  ], 64))
}